import React, { useEffect } from "react";

import { Layout } from "@/shared/ui/Layout/Layout";
import { XadomToast, useToast } from "@/shared/ui/XadomToast";
import { toastEvents } from "@/utils/GlobalUtil";
import { LayoutHeader } from "../../widgets/LayoutHeader";
import { LayoutSidebar } from "../../widgets/LayoutSidebar";

const BaseLayout = () => {
    const { toasts, addToast, removeToast } = useToast();

    useEffect(() => {
        const handleToastEvent = (event: Event) => {
            const customEvent = event as CustomEvent;
            const { message, type, duration, onClose } = customEvent.detail;
            addToast(message, type, duration, onClose);
        };

        toastEvents.addEventListener('show-toast', handleToastEvent);
        
        return () => {
            toastEvents.removeEventListener('show-toast', handleToastEvent);
        };
    }, [addToast]);

    return (
        <>
            <Layout
                sidebarSlot={<LayoutSidebar />} 
                headerSlot={<LayoutHeader />}
            />
            <XadomToast toasts={toasts} onRemove={removeToast} />
        </>
    );
};

const baseLayout = <BaseLayout />;
 
export default baseLayout;